import { AutomationStep, StepError } from '@/types/automationSteps.ts';

export function getStepErrors(
  step: AutomationStep,
  errorType: StepErrorType | StepErrorType[],
): StepError[] {
  if (!Array.isArray(errorType)) {
    errorType = [errorType];
  }

  return step.errors.filter((e) => errorType.includes(e.type));
}

export enum StepErrorType {
  EmptyStepName = 'empty_step_name',
  InvalidDataInput = 'invalid_data_input',
  InvalidRuntimeOutputName = 'invalid_runtime_output_name',
  // InvalidDataOutput = 'invalid_data_output',
  InvalidManualTriggerInput = 'invalid_manual_trigger_input',
  InvalidSchedule = 'invalid_schedule',
  InvalidSubAutomationTarget = 'invalid_sub_automation_target',
  InvalidSubAutomationInputMapping = 'invalid_sub_automation_input_mapping',
  InvalidSubAutomationCycle = 'invalid_sub_automation_cycle',
  InvalidIntegration = 'invalid_integration',
  InvalidIntegrationAction = 'invalid_integration_action',
  InvalidIntegrationConfigValue = 'invalid_integration_config_value',
  ExtractNoDataInputs = 'extract_no_data_inputs',
  InvalidExtractFieldsDataInput = 'invalid_extract_fields_data_input',
  ExtractEntityEmptyDescription = 'extract_entity_empty_description',
  ExtractEntityInvalidDataInput = 'extract_entity_invalid_data_input',
  ExtractEntityInvalidIdentifierContract = 'extract_entity_invalid_identifier_contract',
  ExtractEntityInvalidProvidedValues = 'extract_entity_invalid_provided_values',
  ExtractEntityInvalidRoutingMode = 'extract_entity_invalid_routing_mode',
  ExtractFieldDuplicateId = 'extract_field_duplicate_id',
  ExtractFieldInvalidId = 'extract_field_invalid_id',
  ExtractFieldDuplicateName = 'extract_field_duplicate_name',
  ExtractFieldEmptyName = 'extract_field_empty_name',
  ExtractFieldInvalidDependency = 'extract_field_invalid_dependency',
  ExtractFieldCircularDependency = 'extract_field_circular_dependency',
  ExtractInsightInvalidId = 'extract_insight_invalid_id',
  ExtractInsightEmptyName = 'extract_insight_empty_name',
  ExtractInsightEmptyDescription = 'extract_insight_empty_description',
  ExtractInvalidExtractCount = 'extract_invalid_extract_count',
  EmptyDescription = 'empty_description',
  PreferDeterministicSelection = 'prefer_deterministic_selection',
  InvalidLogicDataInput = 'invalid_logic_data_input',
  InvalidFilterSelectionCount = 'invalid_filter_selection_count',
  InvalidCodeInputBinding = 'invalid_code_input_binding',
  InvalidProvidedCode = 'invalid_provided_code',
  InvalidStepWait = 'invalid_step_wait',
  InvalidStepGate = 'invalid_step_gate',
  InvalidSchemaRef = 'invalid_schema_ref',
  InvalidTransformOutputType = 'invalid_transform_output_type',
  EmptyOutputName = 'empty_output_name',
  InvalidRepeatCount = 'invalid_repeat_count',
  InvalidConditionDataInput = 'invalid_condition_data_input',
  InvalidChildOutput = 'invalid_child_output',
  NoChildSteps = 'no_child_steps',
  DuplicateConditionName = 'duplicate_condition_name',
  DuplicateConditionId = 'duplicate_condition_id',
  InvalidConditionalDisabledState = 'invalid_conditional_disabled_state',
  InvalidConditionAction = 'invalid_condition_action',
  InvalidConditionalLiteralOutput = 'invalid_conditional_literal_output',
}
